"use client";

import { motion } from "motion/react";
import {
  Building2,
  Construction,
  Sprout,
  Map,
  Ruler,
  Camera,
} from "lucide-react";
import { Link } from "@/i18n/navigation";
import { useTranslations } from "next-intl";

const services = [
  {
    icon: Building2,
    msgKey: "realEstate" as const,
    color: "text-blue-600",
    bg: "bg-blue-50",
  },
  {
    icon: Construction,
    msgKey: "construction" as const,
    color: "text-orange-600",
    bg: "bg-orange-50",
  },
  {
    icon: Sprout,
    msgKey: "agriculture" as const,
    color: "text-green-600",
    bg: "bg-green-50",
  },
  {
    icon: Ruler,
    msgKey: "surveying" as const,
    color: "text-purple-600",
    bg: "bg-purple-50",
  },
  {
    icon: Map,
    msgKey: "infrastructure" as const,
    color: "text-red-600",
    bg: "bg-red-50",
  },
  {
    icon: Camera,
    msgKey: "filming" as const,
    color: "text-pink-600",
    bg: "bg-pink-50",
  },
];

export default function ServicesSection() {
  const t = useTranslations("Services");

  return (
    <div className="bg-gray-50 py-20">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="mb-16 text-center">
          <h2 className="mb-4 text-4xl font-bold text-gray-900">
            {t("title")}
          </h2>
          <p className="mx-auto max-w-2xl landing-text-lead text-gray-600">
            {t("subtitle")}
          </p>
        </div>

        <div className="grid grid-cols-2 gap-6 md:grid-cols-3 lg:grid-cols-6">
          {services.map((service, index) => (
            <motion.div
              key={service.msgKey}

              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              whileHover={{ y: -5, scale: 1.05 }}
              className="group text-left"
            >
              <Link href={`/solutions/industries/${({ realEstate: "real-estate", construction: "construction", agriculture: "agriculture", surveying: "surveying-and-mapping", infrastructure: "utilities", filming: "filming-and-media" } as const)[service.msgKey]}`} className="block text-center rounded-lg focus-visible:outline focus-visible:outline-2 focus-visible:outline-accent">
                <div
                  className={`mb-4 inline-flex h-20 w-20 items-center justify-center rounded-2xl transition group-hover:shadow-lg ${service.bg} ${service.color}`}
                >
                  <service.icon className="h-10 w-10" />
                </div>
                <div className="landing-text-body font-semibold text-gray-900">
                  {t(service.msgKey)}
                </div>
              </Link>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
}
